import { pick, shuffle, avoidRepeats } from '@/util/array'

export function exerciseString34 (characters) {
  let choices = characters.split('')
  const length = choices.length
  for (let i = 0; i < 12 - length; i++) {
    choices.push(pick(choices))
  }

  choices = avoidRepeats(shuffle(choices))

  let sArr2D = []
  let k = 0
  for (let i = 0; i < 4; i++) {
    sArr2D[i] = []
    for (let j = 0; j < 3; j++) {
      sArr2D[i][j] = choices[k]
      k++
    }
  }

  return sArr2D
}

/* 组合进阶专用 */
export function exerciseString54 (characters) {
  let choices = characters.split('')
  const length = choices.length
  if (length < 20) {
    for (let i = 0; i < 20 - length; i++) {
      choices.push(pick(choices))
    }
  } else {
    choices.splice(0, length - 20)
  }

  choices = avoidRepeats(shuffle(choices))

  let sArr2D = []
  let k = 0
  for (let i = 0; i < 4; i++) {
    sArr2D[i] = []
    for (let j = 0; j < 5; j++) {
      sArr2D[i][j] = choices[k]
      k++
    }
  }

  return sArr2D
}

/** 英打檢定專用 */
export function getBlocks (essay) {
  const numOfRows = 8
  const lengthOfRow = 70
  let previousTail = 0
  let blockArr = []
  let blockStr = ''
  let currentTail = 0
  let temp = ''
  let blocks = []
  let essayRemain = essay.length
  while (essayRemain > 0) {
    blockArr = []
    for (let i = 0; i < numOfRows; i++) {
      temp = essay.substring(previousTail, previousTail + lengthOfRow)
      if (temp.indexOf('\n') >= 0) {
        currentTail = temp.indexOf('\n') + 1
      } else {
        currentTail = temp.lastIndexOf(' ') + 1
      }
      blockArr[i] = temp.substring(0, currentTail).split('')
      blockStr += temp.substring(0, currentTail)
      previousTail += currentTail
    }
    blocks.push([...blockArr])
    essayRemain -= blockStr.length
  }
  return blocks
}

export function countDiff (str1, str2) {
  let count = 0
  str2.split('').forEach((val, i) => {
    if (val !== str1.charAt(i)) {
      count += 1
    }
  })
  return count
}

export function leading0 (num, size) {
  var s = String(num)
  while (s.length < (size || 2)) { s = '0' + s }
  return s
}
